import styled from 'styled-components'
import Tippy from '@tippyjs/react'
import { Table } from 'react-bootstrap'

export const ReservationsTableWrapper = styled.div`
  width: 100%;
  border: 1px solid var(--primary);
  border-radius: 4px;
  background: var(--white);
  overflow: hidden;
`

export const ReservationsTableScroll = styled.div`
  overflow-x: auto;
  width: 100%;
`

export const ReservationsTable = styled(Table)`
  && {
    margin-bottom: 0;
    border: none;

    thead th {
      border: none;
      border-bottom: 1px solid var(--primary);
      color: var(--primary);
      font-size: 16px;
      font-weight: 400;
      line-height: 140%;
      padding: 12px 16px;
      background: var(--white);
      white-space: nowrap;

      &:last-child {
        text-align: right;
      }
    }

    tbody tr {
      background: var(--white);
      border-bottom: 1px solid var(--border-light);

      &:last-child {
        border-bottom: none;
      }

      td {
        border: none;
        color: var(--grey);
        font-size: 16px;
        font-weight: 400;
        line-height: 140%;
        padding: 12px 16px;
        vertical-align: middle;
        background: var(--white);

        &:last-child {
          text-align: right;
        }
      }
    }
  }
`

export const RequesterLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: var(--grey);
  font-size: inherit;
  font-weight: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: var(--primary);
  }
`

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  text-align: center;
  white-space: nowrap;

  ${({ $status }) => {
    switch ($status) {
      case 'pendente':
        return `
          background: var(--status-pending-bg);
          color: var(--status-pending);
        `
      case 'aprovada':
        return `
          background: var(--green-light);
          color: var(--green-dark);
        `
      case 'reprovada':
        return `
          background: var(--status-rejected-bg);
          color: var(--status-rejected);
        `
      case 'cancelada':
        return `
          background: var(--status-cancelled-bg);
          color: var(--status-cancelled);
        `
      default:
        return `
          background: var(--grey-surface);
          color: var(--grey);
        `
    }
  }}
`

export const ActionMenuTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--primary);
  border-radius: 4px;
  color: var(--primary);
  cursor: pointer;

  &:hover {
    background: var(--primary-hover-bg);
  }
`

export const ActionMenuTippy = styled(Tippy)`
  && .tippy-box {
    background: transparent;
    border: none;
    box-shadow: none;
  }

  && .tippy-content {
    padding: 0;
  }
`

export const ActionMenuPanel = styled.div`
  padding: 8px 0;
  background: var(--white);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  min-width: 210px;
`

const actionItemColor = ($variant: 'edit' | 'approve' | 'reject' | 'cancel'): string => {
  switch ($variant) {
    case 'approve':
      return 'var(--green-dark)'
    case 'reject':
      return 'var(--red)'
    case 'edit':
    case 'cancel':
      return 'var(--grey)'
    default:
      return 'var(--grey)'
  }
}

export const ActionMenuItem = styled.button<{
  $variant: 'edit' | 'approve' | 'reject' | 'cancel'
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 400;
  line-height: 140%;
  text-align: left;
  color: ${({ $variant }) => actionItemColor($variant)};
  cursor: pointer;

  svg {
    flex-shrink: 0;
    width: 16px;
    font-size: 16px;
    color: ${({ $variant }) => actionItemColor($variant)};
  }

  &:hover {
    background: var(--grey-hover);
  }
`

export const ActionCell = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const EmptyTableMessage = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.95rem;
`
